module.exports = __webpack_public_path__ + "img/couples_15_H.a1ab4c62.webp";